import React, { useState, useEffect } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import { APIURL, TZ } from "../../../Global";
import bill from "../../../assets/images/bill.png";
import remind from "../../../assets/images/remind.png";
import { Modal } from "react-bootstrap";
import { Button, Card, ListGroup, ListGroupItem } from "react-bootstrap";
import ZoomableImage from "../Clinics/ZoomableImage";
import { useAlert } from "react-alert";
import { Tooltip } from "react-bootstrap";
import { OverlayTrigger } from "react-bootstrap";
// import PaymentInvoiceLiability from "./PaymentInvoiceLiability";
let lastPageCalled1 = 1
function LiabilitiesAll() {
  const alert = useAlert();
  const [liabilities, setLiabilities] = useState([])
  const [consentView, setConsentView] = useState(false);
  const [img, setImg] = useState("")
  const [checkIds, setCheckIds] = useState([])
  const [invoiceShow, setInvoiceShow] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [hasNext1, setHasNext1] = useState(false)
  const [page1, setPage1] = useState(1)
   const [view, setView] = useState("licenses");
  let navigate = useNavigate();
  let lastScrollTop1 = 0;
  let lastScrollLeft1 = 0;

  useEffect(() => {
    const scrollContainer = document.getElementById('docScrollable');
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', handleScroll1);

      return () => {
        scrollContainer.removeEventListener('scroll', handleScroll1);
      };
    }
  }, [page1, hasNext1]);
  const handleScroll1 = (event) => {
    const scrollContainer = event.target;
    const { scrollTop, scrollLeft, clientHeight, scrollHeight, clientWidth, scrollWidth } = scrollContainer;

    const isVerticalScroll = Math.abs(scrollTop - lastScrollTop1) > Math.abs(scrollLeft - lastScrollLeft1);
    lastScrollTop1 = scrollTop;
    lastScrollLeft1 = scrollLeft;

    const isBottom = scrollTop + clientHeight >= scrollHeight - 10;

    if (isBottom && hasNext1 && isVerticalScroll && (page1 !== lastPageCalled1)) {
      handleLoad(page1);
      lastPageCalled1 = page1;
    }
  };
  useEffect(() => {
   
  
    lastPageCalled1 = 1
  
    setPage1(1)
    setLiabilities([])
   
   
      handleLoad(1);
    
  }, [refresh,view]);
  const handleLoad = async (currentPage) => {
    const tokenString = sessionStorage.getItem('usertoken');

    let str = tokenString.replace(/["]+/g, '')

    axios.get(`${APIURL}/api/v1/staff/hospital-license-bills/?${TZ}&bill_type=${view}&per_page=10&page=${currentPage}`, {
      headers: {

        "Authorization": 'Token ' + str
      }
    })
      .then(res => {

        if (res.data.status === "success") {
          let Data = []
          Data = res.data.message
        
          setLiabilities([...liabilities,...Data])

          setHasNext1(res.data.has_next)
          setPage1(res.data.page+1)
        }


      })
      .catch(err => {

      })


  }
  const ConsentPopUp = (props) => {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}

      >
        <Modal.Header closeButton></Modal.Header>

        <Modal.Body
          style={{ padding: "7%" }}
        >
          <div style={{ textAlign: "center" }}>
            <ZoomableImage src={img} />
          </div>
        </Modal.Body>
        <Modal.Footer>

        </Modal.Footer>
      </Modal>
    );
  };
  const InvoicePopup20 = (props) => {
    // const consultData = config.find(item => { return item.name === 'Consultation' })

    return (
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>


        </Modal.Header>
        <Modal.Body className="text-center">
          {/* <PaymentInvoiceLiability
              id={checkIds}
            //   hospId={hospId}
              onSuccess={() => {setInvoiceShow(false); setRefresh(!refresh);setCheckIds([]) }}
            /> */}
        </Modal.Body>

      </Modal>
    );
  };
  return (
    <div className="" style={{  margin: "auto", minHeight: "71vh",fontSize:"14px" }}>
      <div style={{display:"flex"}}>
      <button className="clinic_button col-2" style={{backgroundColor:view==="licenses"?"#55479F":"white",color:view==="licenses"?"white":"#55479F",}} onClick={() => {setLiabilities([]);setView("licenses")}}>License</button>
      <button className="clinic_button col-2" style={{backgroundColor:view==="credits"?"#55479F":"white",color:view==="credits"?"white":"#55479F",}}onClick={() => {setLiabilities([]);setView("credits")}}>Credit</button>
      <button className="clinic_button col-2" style={{backgroundColor:view==="special_feature"?"#55479F":"white",color:view==="special_feature"?"white":"#55479F",}}onClick={() => {setLiabilities([]);setView("special_feature")}}>Special Features</button>
      <button className="clinic_button col-2" style={{backgroundColor:view==="plan"?"#55479F":"white",color:view==="plan"?"white":"#55479F",}}onClick={() => {setLiabilities([]);setView("plan")}}>Plan</button>
      <button className="clinic_button col-2" style={{backgroundColor:view===""?"#55479F":"white",color:view===""?"white":"#55479F",}}onClick={() => {setLiabilities([]);setView("")}}>All</button>
      </div>
      <div style={{ marginBottom: "2%" }} className="row" >
        {liabilities.length > 0 ?


          <div className="" style={{}}>
            <h6 className="row"><span className="col-3" ></span>
              <div className="col-7"></div>
              <div className="col-2">

                {/* <button onClick={() => {  setInvoiceShow(true)  }
                         } style={{ backgroundColor:"rgb(85, 71, 159)" }} className="clinic_button">
                          Generate invoice
                         </button> */}

              </div>

            </h6>
            <div id="docScrollable" style={{ overflowY: "auto", overflowX: "hidden", maxHeight: "380px", paddingRight: "2%", paddingLeft: "2%",marginBottom:"2%" }}>
            <div className="row " style={{ backgroundColor: "rgba(85, 71, 159, 0.72)", color: "white", textAlign: "left", padding: "1%", borderRadius: "5px 5px 0px 0px" }}>
              {/* <div  className="col-1">ID</div> */}
              <div className="col-2">Service provider</div>
              <div className="col-2">Item</div>
              <div className="col-3"><b >Generated</b>
              <div className=""style={{ float:"right",paddingRight:"5%"}}><b >Renewal</b></div></div>
              <div className="col-2"><b >Total </b></div>
              <div className="col-1"><b >Paid </b></div>
             
              <div className="col-1"><b >Liability</b></div>
              {/* <div className="col-2"><b >Payment status</b></div> */}
              <div className="col-1"></div>

            </div>
           
            {liabilities && liabilities.map((item) => {
              return (<div  className="row " style={{ textAlign: "left", borderLeft: "0.4px solid gray", borderBottom: "0.4px solid gray", borderRight: "0.4px solid gray" }}>
                {/* <div  style={{ padding:"1%",color:"blue",cursor:"pointer"}}className="col-1">{item.id}</div> */}
                <div onClick={() => navigate(`/hospital-details/${item.hospital_id}`, {
                  state: {
                    selected: "liabilities",
                  }
                })} style={{ padding: "1%", textTransform: "capitalize", color: "blue", cursor: "pointer" }} className="col-2"><spsn style={{color:"rgba(85, 71, 159, 0.72)"}}>{item.id}</spsn>{" "}{item.hospital_name}</div>
                <div style={{ padding: "1%", overflow:"clip" }} className="col-2"> {(item.item_name&&item.item_name!==null)?item.item_name.replace(/_/g, ' '):item.bill_type}</div>
                <div style={{ padding: "1%" }} className="col-3">{item.bill_generated_date}
                <div style={{ float:"right",paddingRight:"5%"}} > {item.renewal_date}</div></div>
                <div style={{ padding: "1%" }} className="col-2">QAR {item.total_license_amount}/-</div>
                <div style={{ padding: "1%" }} className="col-1">QAR {item.total_license_amount - item.liability}/-</div>
                
                <div   className="col-2"style={{ padding: "1%"}}><b style={{ padding: "1%", color: "orange", cursor: "pointer" }} onClick={(e) => { setImg(item.bill_image ? item.bill_image : bill); setConsentView(true); }}>QAR {item.liability}/-</b>
                {/* <div style={{ padding:"1%"}}className="col-2">{item.payment_status}</div> */}
               {(item.bill_type!=='credits')&& <div style={{ padding: "0.5%",float:"right",cursor:"not-allowed" }}  >
                   <OverlayTrigger overlay={<Tooltip style={{ textTransform: "capitalize" }} id="tooltip-disabled">Resend bill</Tooltip>}>
                   <svg   
                  //   onClick={(e) => {
                  //   setLiabilities([])
                  //   const tokenString = sessionStorage.getItem('usertoken');

                  //   let str = tokenString.replace(/["]+/g, '')

                  //   axios.get(`${APIURL}/api/v1/staff/generate-provisional-bills/?bill_id=${item.id}&${TZ}`, {
                  //     headers: {

                  //       "Authorization": 'Token ' + str
                  //     }
                  //   })
                  //     .then(res => {

                  //       if (res.data.status === "success") {
                  //        alert.success(res.data.message)
                  //        setRefresh(!refresh)
                  //       }


                  //     })
                  //     .catch(err => {

                  //     })
                  // }} 
                  xmlns="http://www.w3.org/2000/svg" style={{marginTop:"4%"}} width="24" height="24" viewBox="0 0 24 24"><path fill="#2b69a3" d="M3 4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h10.5a6.5 6.5 0 0 1-.5-2.5a6.5 6.5 0 0 1 6.5-6.5a6.5 6.5 0 0 1 1.5.18V6a2 2 0 0 0-2-2zm0 2l8 5l8-5v2l-8 5l-8-5zm16 6l-2.25 2.25L19 16.5V15a2.5 2.5 0 0 1 2.5 2.5c0 .4-.09.78-.26 1.12l1.09 1.09c.42-.63.67-1.39.67-2.21c0-2.21-1.79-4-4-4zm-3.33 3.29c-.42.63-.67 1.39-.67 2.21c0 2.21 1.79 4 4 4V23l2.25-2.25L19 18.5V20a2.5 2.5 0 0 1-2.5-2.5c0-.4.09-.78.26-1.12z"/></svg>
                              
                             </OverlayTrigger>
                </div>}
                </div>
              </div>
              )
            })}

</div>


          </div>

          :
          <div
            style={{
              color: "red",
              fontSize: "25px",
              height: "200px",
              padding: "10%",
            }}
          >
            <h4>No Liabilities!!</h4>
          </div>}
        {consentView ? (
          <ConsentPopUp
            show={consentView}
            onHide={() => setConsentView(false)}
          />
        ) : null}
        {invoiceShow ? (
          <InvoicePopup20
            show={invoiceShow}
            onHide={() => {
              setInvoiceShow(false);
              setCheckIds([])
            }}
          />
        ) : null}
      </div>
    </div>
  );
}
export default LiabilitiesAll;
